/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { convertRegisterStage, RegisterStage } from '../../api/enumerations';
import Snackbar from '../../components/Snackbar';
import { GlobalContext } from '../../context/global';
import {
  getLocalStorageToken,
  removeLocalStorageToken,
} from '../../helpers/localStorage';
import { AuthMethod } from './AuthMethod';
import { ConfirmationAuthMethod } from './ConfirmationAuthMethod';
import Password from './Password';
import {
  ContainerGrid,
  InputBox,
  LoginGrid,
  LogoGrid,
  LogoImg,
  Title,
} from './styles';

interface IComponent {
  stage: RegisterStage;
  title?: string;
  component: JSX.Element;
}

export default function CreateAccount({ logo }: { logo: string }): JSX.Element {
  const [stageNumber, setStageNumber] = useState(RegisterStage.PASSWORD);
  const [component, setComponent] = useState<IComponent>();
  const [passwordToken, setPasswordToken] = useState('');

  const { openSnackbar } = useContext(GlobalContext);
  const location = useLocation();

  const search = new URLSearchParams(location.search);
  const accessToken = search.get('token') || '';

  const token = getLocalStorageToken();

  useEffect(() => {
    if (token) {
      removeLocalStorageToken();
    }
  }, [token]);

  const handleNextStage = (stage: RegisterStage): void => {
    setStageNumber(stage);
  };

  const components = [
    {
      stage: RegisterStage.PASSWORD,
      title: convertRegisterStage(RegisterStage.PASSWORD),
      component: (
        <Password
          handleNextStage={handleNextStage}
          setPasswordToken={setPasswordToken}
          accessToken={accessToken}
        />
      ),
    },
    {
      stage: RegisterStage.AUTH_METHOD,
      component: (
        <AuthMethod token={passwordToken} handleNextStage={handleNextStage} />
      ),
    },
    {
      stage: RegisterStage.CONFIRMATION_AUTH_METHOD,
      component: <ConfirmationAuthMethod />,
    },
  ];

  useEffect(() => {
    const element = components.find(
      (component) => component.stage === stageNumber
    );
    setComponent(element);
  }, [stageNumber]);

  return (
    <ContainerGrid container>
      <LogoGrid item xs={6.5} xl={7.5}>
        <LogoImg>
          <img src={logo} alt="Logo" />
        </LogoImg>
      </LogoGrid>
      <LoginGrid item xs={5.5} xl={4.5}>
        <InputBox>
          {component?.title && <Title>{component?.title}</Title>}
          {component?.component}
        </InputBox>
      </LoginGrid>
      {openSnackbar && <Snackbar />}
    </ContainerGrid>
  );
}
